if (!customElements.get('zoom-image')) {
  customElements.define(
    'zoom-image',
    class ZoomImage extends HTMLElement {
      constructor() {
        super();
        this.image = this.querySelector('img');
        this.pzInstance = null;

        if (this.dataset.key == '1') {
          this.initializePinchZoom();
        }

        document.addEventListener('slideChanged', (event) => {
          if (event.detail.currentPage == this.dataset.key) {
            this.initializePinchZoom();
          } else {
            this.destroyPinchZoom();
          }
        });

        document
          .querySelector(".product-media-modal__toggle")
          .addEventListener("click", (event) => {
            this.pzInstance.zoomOut();
 
            this.image
              .closest(".slider__slide")
              .classList.remove("pinch-zoom-out");
            this.image.closest(".slider__slide").classList.add("pinch-zoom-in");
          });

        document.addEventListener('openModal', (event) => {
          if (event.detail.key == this.dataset.key) {
            this.showImageWithoutScroll();
            this.initializePinchZoom();
          }
        });

        document.addEventListener('closeModal', (event) => {
          if (event.detail.key == this.dataset.key) {
            this.syncCarouselToSelectedImage();
          }
          this.destroyPinchZoom();
        });
      }

      initializePinchZoom() {
        if (this.pzInstance) return;

        this.pzInstance = new PinchZoom(this.image, {
          minZoom: 1,
          tapZoomFactor: 2,
          maxZoom: 4,
          use2d: false,
          verticalPadding: 0,
          draggableUnzoomed: false,
          onDragStart: () => {
            this.image.classList.toggle('zoomed-in');
            this.image.classList.add('dragging');
          },
          onDragEnd: () => {
            this.image.classList.remove('dragging');
          },
        });
      }

      destroyPinchZoom() {
        if (this.pzInstance) {
          this.pzInstance.destroy();
          this.pzInstance = null;
        }
      }

      showImageWithoutScroll() {
        const slider = this.closest('.slider');
        if (slider) {
          const slides = slider.querySelectorAll('.slider__slide');
          slides.forEach((slide) => slide.classList.remove('active'));

          this.closest('.slider__slide').classList.add('active');

          slider.scrollTo({
            left: this.offsetLeft,
            behavior: 'instant',
          });
        }
      }

      syncCarouselToSelectedImage() {
        const slider = document.querySelector('.slider');
        if (slider) {
          const activeSlide = slider.querySelector('.slider__slide.active');
          if (activeSlide) {
            slider.scrollTo({
              left: activeSlide.offsetLeft,
              behavior: 'instant', 
            });
          }
        }
      }
    }
  );
}

document.querySelectorAll('.slider__slide').forEach((slide) => {
  slide.addEventListener('click', () => {
    if (slide.classList.contains('pinch-zoom-in')) {
      slide.classList.remove('pinch-zoom-in');
      slide.classList.add('pinch-zoom-out');
    } else {
      slide.classList.remove('pinch-zoom-out');
      slide.classList.add('pinch-zoom-in');
    }
  });
});

document.querySelectorAll('.product-media-modal__toggle').forEach((button) => {
  button.addEventListener('click', (event) => {
    const key = event.target.dataset.key;
    const openModalEvent = new CustomEvent('openModal', { detail: { key } });
    document.dispatchEvent(openModalEvent);
  });
});

document.querySelectorAll('.product-media-modal__close').forEach((button) => {
  button.addEventListener('click', (event) => {
    const key = event.target.dataset.key;
    const closeModalEvent = new CustomEvent('closeModal', { detail: { key } });
    document.dispatchEvent(closeModalEvent);
  });
});